@if (loading) {
  <mat-spinner diameter="24"></mat-spinner>
} @else {
  <div class="dual-list">
    <div class="list-column">
      <h4>Available Buyer Groups</h4>
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Available Buyer Groups</mat-label>
        <input matInput [formControl]="searchAvailable">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <div
        cdkDropList
        id="available-groups"
        #availableList="cdkDropList"
        [cdkDropListData]="filteredAvailable"
        [cdkDropListConnectedTo]="assignedList"
        [cdkDropListDisabled]="readonly"
        class="drop-list"
        (cdkDropListDropped)="onDrop($event)"
      >
        @for (group of filteredAvailable; track group.group_id) {
          <div cdkDrag [cdkDragData]="group" class="drop-item" [class.disabled]="readonly" (click)="onClickMove(group, true)">
            <mat-icon class="drag-handle">drag_indicator</mat-icon>
            <span>{{ group.name }}</span>
          </div>
        } @empty {
          <div class="empty-message">No available groups</div>
        }
      </div>
    </div>

    <div class="list-column">
      <h4>Selected Buyer Groups</h4>
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search Selected Buyer Groups</mat-label>
        <input matInput [formControl]="searchAssigned">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <div
        cdkDropList
        id="assigned-groups"
        #assignedList="cdkDropList"
        [cdkDropListData]="filteredAssigned"
        [cdkDropListConnectedTo]="availableList"
        [cdkDropListDisabled]="readonly"
        class="drop-list"
        (cdkDropListDropped)="onDrop($event)"
      >
        @for (group of filteredAssigned; track group.group_id) {
          <div cdkDrag [cdkDragData]="group" [cdkDragDisabled]="isShared(group)"
            class="drop-item" [class.disabled]="readonly || isShared(group)"
            (click)="isShared(group) ? null : onClickMove(group, false)">
            <mat-icon class="drag-handle">drag_indicator</mat-icon>
            <span>{{ group.name }}</span>
            @if (isShared(group)) {
              <mat-icon class="shared-icon" title="Shared group — managed by the original owner">link</mat-icon>
            }
          </div>
        } @empty {
          <div class="empty-message">No assigned groups</div>
        }
      </div>
    </div>
  </div>
}
